exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".links[data-v-17aa08d0]{display:flex;flex-direction:column;margin-right:auto;gap:10px}.links a[data-v-17aa08d0]{display:inline-block;padding:10px 20px;border-radius:10px;text-decoration:none;background-color:#ccc}.links a[data-v-17aa08d0]:hover{background-color:#ddd}", ""]);

